import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Shield, Lock, Globe, Check, Zap, Sparkles } from 'lucide-react';
const comboIncludes = ['120 Ready-to-Teach Yoga Classes', '9 yoga class categories', '40+ weeks without repeating', 'Every class fully structured', 'Scripts, cues & transitions included', 'Bonus 1 — 52 Weekly Teaching Themes', 'Bonus 2 — Ultimate Cueing Library', 'Bonus 3 — Beginner Modification Guide', 'Bonus 4 — 30 Emergency Classes', 'Bonus 5 — Class Finder System', '7-day money-back guarantee'];
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-black relative" data-id="element-192">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-[500px] bg-gold/20 blur-[120px] rounded-full pointer-events-none" data-id="element-193"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-194">
        <div className="text-center mb-10" data-id="element-195">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3" data-id="element-196">
            Your Complete Offer Today
          </h2>
          <p className="text-gold-light text-sm md:text-base" data-id="element-197">
            The complete teaching library + 5 strategic bonuses — ready for your
            next class.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-dark-card border-2 border-gold rounded-3xl p-1 relative shadow-[0_0_50px_rgba(212,175,55,0.2)]" data-id="element-198">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-gradient text-black font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-199">
            <Sparkles size={14} data-id="element-200" /> Complete Pack
          </div>

          <div className="bg-black rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-201">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-gradient mb-3" data-id="element-202">
              Yoga Teacher Ready™
            </h3>
            <p className="text-base text-gray-300 mb-6" data-id="element-203">
              Everything you need to teach yoga with confidence.
            </p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-gold/5 border border-gold/20 rounded-xl p-4" data-id="element-204">
              {comboIncludes.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-205">
                  <Check size={16} className="text-gold shrink-0 mt-0.5" data-id="element-206" />
                  <span data-id="element-207">{item}</span>
                </li>)}
            </ul>

            <div className="mb-6" data-id="element-208">
              <span className="text-lg text-gray-500 line-through block mb-1" data-id="element-209">
                USD 105.00
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-210">
                <span className="text-2xl md:text-3xl text-white" data-id="element-211">TODAY:</span>
                <span className="text-4xl md:text-5xl font-bold text-gold" data-id="element-212">
                  USD 27.00
                </span>
              </div>
            </div>

            <Button href="https://yoga-teacher-ready.impultienda.ar/checkout" target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Yoga Teacher Ready Complete Pack',
                value: 27.0,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-213">
              🟡 GET THE COMPLETE TEACHING LIBRARY NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-gray-400 mb-4" data-id="element-214">
              <span className="flex items-center gap-1.5" data-id="element-215">
                <Lock size={12} className="text-gold" data-id="element-216" /> Secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-217">
                <Zap size={12} className="text-gold" data-id="element-218" /> Immediate access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-219">
                <Shield size={12} className="text-gold" data-id="element-220" /> 7-day guarantee
              </span>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-221">
              <Globe className="text-gold shrink-0 mt-0.5" size={14} data-id="element-222" />
              <p className="text-[11px] text-gray-400 leading-snug" data-id="element-223">
                Pay in your local currency. The amount adapts automatically
                based on the country you are purchasing from.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}